
const INTERNAL_CLAIM_PATTERNS = [/clearinghouse/i, /edi/i, /277ca/i, /835/i, /candid/i, /stedi/i];

/** Maps stored claim ids to a short client-facing claim number. */
export function toClientClaimNumber(claimId?: string): string | undefined {
  if (!claimId || isInternalClaimDetail(claimId)) return undefined;
  if (/^CLM-/i.test(claimId)) return claimId.toUpperCase();
  const compact = claimId.replace(/[^A-Za-z0-9]/g, '').slice(-8).toUpperCase();
  return compact ? `CLM-${compact}` : undefined;
}

export function isInternalClaimDetail(value?: string): boolean {
  if (!value) return false;
  return INTERNAL_CLAIM_PATTERNS.some((p) => p.test(value));
}
